import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
} from "ckeditor5";

function EditFaq({ question, answer, id }) {
  const [questionData, setQuestionData] = useState("");
  const [answerData, setAnswerData] = useState("");

  console.log("questionDataPreview", questionData);
  return (
    <div className="w-full p-5 mt-5 flex flex-col gap-5">
      <div>Back</div>
      <div className="w-full">
        {/* <input placeholder="Enter Question" /> */}
        <span>Edit Question:</span>
        <div
          style={{
            // border: "1px solid #ccc",
            padding: "10px",
            marginTop: "10px",
            lineHeight: "1.6",
          }}
        >
          <style>
            {`
            ul, ol {
              margin: 0;
              padding-left: 20px;
              list-style: disc; /* Ensure bullet points */
            }
            ol {
              list-style: decimal; /* Ensure ordered list numbers */
            }
            li {
              margin-bottom: 5px;
            }
          `}
          </style>

          <div
            dangerouslySetInnerHTML={{ __html: questionData }}
            style={{
              // Reset styles for lists
              ul: { paddingLeft: "20px", listStyleType: "disc" },
              ol: { paddingLeft: "20px", listStyleType: "decimal" },
              li: { marginBottom: "5px" },
            }}
          />
        </div>
        <CKEditor
          data={questionData}
          editor={ClassicEditor}
          onChange={(event, editor) => {
            const data = editor.getData();
            console.log({ event, editor, data }); // Logs the editor data in the console
            setQuestionData(data); // Update state with the editor content
          }}
          config={{
            licenseKey: "GPL", // Use the GPL license.
            plugins: [
              Essentials,
              Paragraph,
              Bold,
              Italic,
              Heading,
              Link,
              List,
              BlockQuote,
              Image,
              Table,
              MediaEmbed,
              PasteFromOffice,
              Font,
              Alignment,
            ],
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "|",
              "bulletedList",
              "numberedList",
              "|",
              "blockQuote",
              "insertTable",
              "|",
              "undo",
              "redo",
              "|",
              "alignment:left",
              "alignment:center",
              "alignment:right",
              "alignment:justify",
              "|",
              "fontColor",
              "fontBackgroundColor",
              "fontSize",
              "|",
              "mediaEmbed",
            ],
          }}
        />
      </div>
      <div className="w-full mt-10">
        <span>Edit Answer:</span>
        <div dangerouslySetInnerHTML={{ __html: answerData }} />

        <CKEditor
          editor={ClassicEditor}
          onChange={(event, editor) => {
            const data = editor.getData();
            console.log({ event, editor, data }); // Logs the editor data in the console
            setAnswerData(data); // Update state with the editor content
          }}
          config={{
            licenseKey: "GPL", // Use the GPL license.
            plugins: [
              Essentials,
              Paragraph,
              Bold,
              Italic,
              Heading,
              Link,
              List,
              BlockQuote,
              Image,
              Table,
              MediaEmbed,
              PasteFromOffice,
              Font,
              Alignment,
            ],
            toolbar: [
              "heading",
              "|",
              "bold",
              "italic",
              "link",
              "|",
              "bulletedList",
              "numberedList",
              "|",
              "blockQuote",
              "insertTable",
              "|",
              "undo",
              "redo",
              "|",
              "alignment:left",
              "alignment:center",
              "alignment:right",
              "alignment:justify",
              "|",
              "fontColor",
              "fontBackgroundColor",
              "fontSize",
              "|",
              "mediaEmbed",
            ],
          }}
        />
      </div>
      <div className="w-full justify-center items-center flex">
        <span className="px-4 py-2 bg-[#ffb819] rounded-lg">Submit</span>
      </div>
    </div>
  );
}

export default EditFaq;
